import { isIso639 } from "./Validators";
var LanguageHandler = /** @class */ (function () {
    function LanguageHandler(translations) {
        var _this = this;
        /**
         * Initializes language for the LanguageHandler.
         *
         * @param lang Must comply with ISO 639-1 standard.
         */
        this.init = function (lang) {
            if (!isIso639(lang)) {
                throw "lang param does not comply with ISO 639-1 standard";
            }
            _this.lang = lang;
        };
        /**
         * Gets translated string.
         *
         * @param key Translation id.
         * @returns translation
         */
        this.getString = function (key) {
            if (!_this.lang) {
                throw "Call languageHandler.init(lang) and setup chosen language";
            }
            var translation = _this.translations[_this.lang];
            var keySplit = key.split(".");
            if (keySplit.length <= 1)
                return translation[key];
            var translationValue = translation;
            keySplit.forEach(function (key) {
                translationValue = translationValue[key];
            });
            return translationValue;
        };
        this.translations = translations;
    }
    return LanguageHandler;
}());
export default LanguageHandler;
